import classes from './Badge.module.css';

type Props = {
    icon?: JSX.Element;
    text?: string;
    color?: string;
    textColor?: string;
    onClick?: () => void;
};

const Badge = (props: Props) => (
    <div className={classes.badge} style={{ background: props.color ?? '#E5E5E5' }} onClick={props.onClick}>
        {props.icon}
        <div className={classes.text} style={{ color: props.textColor ?? '#fff' }}>
            {props.text}
        </div>
    </div>
);

export default Badge;
